import React, { CSSProperties } from 'react';
import styled from '@emotion/styled';
import { getBackgroundTheme } from '../../style';
import Spinner from './Spinner/Spinner';

interface LoaderProps {
  active: boolean;
  customStyle?: CSSProperties;
  imgStyle?: CSSProperties;
  showLoadingBg?: boolean;
}

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const StyledLoaderContainer = styled<'div', LoaderProps>('div')((props: any) => ({
  display: props.active ? 'flex' : 'none',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: props.showLoadingBg ? getBackgroundTheme().loader : 'none',
  zIndex: 9999,
  ...(props.customStyle || {}),
}));

const StyledLoader = styled('div')({
  textAlign: 'center',
});

const Loader: React.FC<LoaderProps> = ({ customStyle, imgStyle, active, showLoadingBg = true }) => {
  return (
    <StyledLoaderContainer customStyle={customStyle} active={active} showLoadingBg={showLoadingBg}>
      <StyledLoader>
        <Spinner customStyle={imgStyle} />
      </StyledLoader>
    </StyledLoaderContainer>
  );
};

export default Loader;
